module.exports = __webpack_public_path__ + "static/sports-guide-3bf8979461d4a03f44851f143fe77c8c.jpg";